import { styled, Switch, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import * as React from 'react';
import DarkIcon from "./dark.svg";

export const ColorModeContext = React.createContext({ toggleColorMode: () => { } });

const SwitchStyled = styled(Switch, {
    shouldForwardProp: (prop) => prop !== 'checked',
})<{ checked?: boolean }>(({ theme, checked }) => ({
    '& .MuiSwitch-track': {
        border: '1px solid',
        borderColor: 'rgba(255, 255, 255, 0.30)',
        opacity: '1 !important',
        backgroundColor: checked ? '#222426 !important' : '#2F80ED !important',
        '.Mui-checked + &': {
            backgroundColor: '#222426 !important',
        },
        '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            height: '16px',
            width: '16px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
        },
        '&::before': {
            backgroundImage: `url(${DarkIcon})`,
            left: 10
        },
        '&::after': {
            opacity: checked ? '1 !important' : '0.3 !important',
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
                '#fff',
            )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
            right: 10,
        },
    },
    '& .MuiSwitch-thumb': {
        backgroundColor: checked ? '#fff' : '#f2d74a',
        transition: 'background-color 0.3s',
    },
}));


export function ThemeSwitcher({ open, isProfileMenu }: { open: boolean, isProfileMenu?: boolean }) {
    const theme = useTheme();
    const colorMode = React.useContext(ColorModeContext);
    const [mode, setMode] = React.useState(theme.palette.mode);
    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                justifyContent: isProfileMenu ? 'space-between' : 'center',
                color: 'text.primary',
            }}>
            {open && <Typography fontWeight={700}>Theme: </Typography>}
            <SwitchStyled
                checked={mode === 'dark'}
                defaultChecked={mode === 'dark'}
                size='medium'
                onChange={() => {
                    const newMode = mode === 'light' ? 'dark' : 'light';
                    setMode(newMode);
                    document.documentElement.setAttribute('data-theme', newMode);
                    colorMode.toggleColorMode();
                }}
                color="default"
                inputProps={{ 'aria-label': 'toggle theme' }}
            />
        </Box>
    );
}
